<ic-ui-card class="full-screen custom-header-and-content no-padding">
	<header class="title-section">
		<ic-resident-overview-card data-test="resident-overview-card"></ic-resident-overview-card>

		<div class="title-and-filters">
			<h1>{{ 'general.titles.dashboard' | translate }}</h1>
			<ic-date-filter
				(date)="setDate($event)"
				*userHasPermission="{$or: ['PORTAL.TASKS_WIDGET', 'PORTAL.ALARMS_WIDGET']}"
			></ic-date-filter>
		</div>
	</header>

	<section class="content">
		<a
			data-test="task-overview-page-link"
			routerLink="residents-tasks-status"
			class="small block-2"
			[ngClass]="{'ic-block': hasTasksPermission, 'disable-tasks': !hasTasksPermission}"
		>
			<ic-task-overview-card [dateInput]="date$ | async"> </ic-task-overview-card>
		</a>

		<ng-container *hasFeature="['CallAlarms']">
			<ic-call-signal-overview-card
				class="small block-5"
				[date]="date$ | async"
				[ngClass]="hasAlarmsPermission ? 'ic-block' : ''"
			>
			</ic-call-signal-overview-card>
		</ng-container>
	</section>
</ic-ui-card>
